package com.essntl.core.whatsapp.data.response

import kotlinx.serialization.Serializable

@Serializable
internal data class WhapiChatsResponseDto(
    val chats: List<WhapiChatDto>
)
